import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withViewTransitions} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {HttpClient, provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {ENVIRONMENT} from '@services/enviroment/environment.service';
import {environment} from '../environments/environment';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {tokenInterceptor} from './interceptors/token.interceptor';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withViewTransitions()),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(), provideCharts(withDefaultRegisterables()),
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    provideHttpClient(withInterceptors([tokenInterceptor]),),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ])
  ],
};
